import React, { useContext, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from '../../Asset/image/tamara_logo.png';
import './SideBar.css';
import homeCat1 from '../../Asset/image/home_category1.png';
import homeCat2 from '../../Asset/image/home_category2.png';
import homeCat3 from '../../Asset/image/home_category3.png';
import homeCat4 from '../../Asset/image/home_category4.png';
import historyImg from '../../Asset/image/history.png';
import CustomImage from "../../CommonComponents/CustomImage";
import deleteB from '../../Asset/image/delete.png';
import HistoryModal from "../../CommonComponents/HistoryModal";
import { getHistoryListService, messageActionService } from "../../services/chatService";
import { normalFormateDateTime } from "../../lib/helper";
import { formatAMPM, messageActionOption, paginationLimit, signUpType } from "../../data/constants";
import { toast } from "react-toastify";
import { useAuth } from "../../Context/AuthProvider";
import Loader from "../../CommonComponents/Loader";
import LogoutModal from "../../CommonComponents/LogoutModal";
import MobileSidebar from "./MobileSideBar";
import UseScreenSize from "../../CommonComponents/ScreenSize";
const Sidebar = ({ categoryKey, setCategoryKey, historyData, getList, updateList, totalData, page, setPage, closeNav, mobileSideBar }) => {
    const navigate = useNavigate();
    const { user } = useAuth()
    const [selected, setSelected] = useState(0);
    const [show, setShow] = useState(false);
    const [deleteShow, setDeleteShow] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState(null);
    const handleDeleteShow = () => setDeleteShow(true);
    const handleShow = () => setShow(true);
    const screenSize = UseScreenSize();
    const active = null;
    const renderLoader = () => {
        return (
            <Loader
                visible={false}
                emptyTextKey={'EmptyHistory'}
                style={{ top: 0, position: "relative", color: "white", fontWeight: 25 }} />
        )
    }

    const deleteHistory = async (item) => {
        try {
            const params = { messageid: item.message_id };
            const response = await messageActionService(
                params,
                messageActionOption.unSave,
            );
            toast.success(response?.data);
            if (response?.data) {
                updateList(item);
                getList();
                setDeleteShow(false);
            }
        } catch (error) {
            // showToast(error?.response?.data?.data);
            console.log(error);
        }
    };
    // Sidebar Menus
    const menus = [
        {
            name: 'General',
            value: "general",
            link: '/',
            icon: <CustomImage src={homeCat1} />,
        },
        {
            name: 'Social Media',
            value: "social_media",
            link: '/',
            icon: <CustomImage src={homeCat2} />,
        },
        {
            name: 'Email',
            value: "email",
            link: '/',
            icon: <CustomImage src={homeCat3} />,
        },
        {
            name: 'Meeting Minutes',
            value: "meeting_minute",
            link: '/',
            icon: <CustomImage src={homeCat1} />,
        },
        {
            name: 'Resume',
            value: "resume",
            link: '/',
            icon: <CustomImage src={homeCat1} />,
        },
        {
            name: 'Reports',
            value: "report",
            link: '/',
            icon: <CustomImage src={homeCat1} />,
        },
        {
            name: 'Messages',
            value: "messages",
            link: '/',
            icon: <CustomImage src={homeCat4} />,
        },
    ]

    return (
        <>
            <div className="container ">
                <div className="navigation-widget sidebar closed delayed">
                    <CustomImage style={{ height: "31px", marginLeft: "16px" }} src={Logo} />
                    <div className="sidemenu_scroll spacing_scroll" style={{ overflowY: 'auto', height: "65.5vh" }}>
                        <ul className="menu small">
                            {menus.length && menus.map((item, index) => {
                                let classes = (active === item.link) ? 'menu-item.active' : 'menu-item';
                                return (
                                    <li className={classes} key={index}>
                                        <div className="menu-item-link text-tooltip-tfr mt-4" title={item.name} data-title={item.namw} style={index === selected ? { position: 'relative', backgroundColor: " #0074FE24" } : { position: 'relative' }}
                                            onClick={() => { setCategoryKey(item.value); setSelected(index) }}
                                        >
                                            <div className="xm-tooltip d-flex justify-content-space-between ps-2 py-2 align-items-center" >
                                                <span className="mx-2">{item.icon} </span>  <p className="xm-tooltip-text m-0">{item.name}</p></div>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 d-flex justify-content-between">
                                    <div className="col-md-4 d-flex justify-content-start">
                                        <CustomImage className="iconStyle px-2 mt-1" src={historyImg} />
                                        <p className='text-label' >History</p>

                                    </div>
                                    <div className="col-md-4">
                                        <p className='commentText pointerData' onClick={handleShow}>View All</p>
                                    </div>
                                </div>
                            </div>
                            {!historyData.length ? renderLoader() : historyData.map((item, index) => {
                                if (new Date(item.createdAt).getDate() === new Date().getDate()) {
                                    return (
                                        <div className="d-flex justify-content-between display-box mt-2" key={index}>
                                            <p className='commentText text-capitalize' >{item.categoryname === "meeting_minute" ? "Meeting Minute" : item.categoryname}</p>
                                            <p className=" commentText">{formatAMPM(item.createdAt)}</p>
                                            <CustomImage className="  message_icon" onClick={() => { handleDeleteShow(); setSelectedMessage(item) }} src={deleteB} />
                                        </div>
                                    )
                                }
                            })}
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mt-2">
                                <p className='text-label mt-4' >Tamara ChatBot</p>
                                <p className='commentText'>© Copyright Tamara. 2023</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <LogoutModal show={deleteShow} setShow={setDeleteShow} title="Delete" data="delete this message" onYesClick={() => deleteHistory(selectedMessage)} />
            <HistoryModal show={show} setShow={setShow} getList={getList} historyData={historyData} updateList={updateList} totalData={totalData} page={page} setPage={setPage} />
        </>
    );
}

export default Sidebar;